import axios from "axios";

axios.defaults.withCredentials = true;

export const baseURL = process.env.REACT_APP_API_URL;
export const baseB24URL = process.env.REACT_APP_B24CHAT_API_URL;
export const baseAutomationB24URL = process.env.REACT_APP_AUTOMATION_URL;

const axiosInstance = axios.create({
  baseURL,
  data: {},
  withCredentials: true,
});

const axiosNoTokenInstance = axios.create({
  baseURL,
  data: {},
});

const axiosB24Instance = axios.create({
  baseURL: baseB24URL,
  data: {},
  withCredentials: true,
});

const axiosAutomationInstance = axios.create({
  baseURL: baseAutomationB24URL,
  data: {},
});

const axiosB24NoTokenInstance = axios.create({
  baseURL: baseB24URL,
  data: {},
});

export {
  axiosInstance,
  axiosNoTokenInstance,
  axiosB24Instance,
  axiosAutomationInstance,
  axiosB24NoTokenInstance,
};
